import { openCloseToast } from "../../../../Global/actions";
import {
  deleteProfileApi,
  updateProfileApi,
  createProfileApi,
} from "../../../../../services/perfilesApi";
import { getPerfiles, loading } from "../../General/actions";

/**
 * @description Action para crear el nuevo perfil
 * @param {*} name :Nombre del perfil
 * @param {*} description : Descripcion del nuevo perfil
 */
export const doCreatePerfil = (name, description) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await createProfileApi(name, description);
    if (request.status === 200) {
      dispatch(getPerfiles());
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Perfil creado con éxito",
          typeStyle: "success",
          displayTime: 5000
        })
      );
    } else {
      dispatch(getPerfiles());
      const res = await request.json();
      if (request.status === 403) {
        dispatch(
          openCloseToast({
            isToastOpen: true,
            msgToast: res.Message,
            typeStyle: "warning",
            displayTime: 5000
          })
        );
      } else {
        dispatch(
          openCloseToast({
            isToastOpen: true,
            msgToast: res.Message,
            typeStyle: "error",
            displayTime: 5000
          })
        );
      }
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al crear el perfil",
          typeStyle: "error",
          displayTime: 5000
        })
      );
    }
  } catch (e) {
    console.error(e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión al crear el perfil",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const doUpdatePerfil = (idPerfil, name, description, active) => async (
  dispatch
) => {
  dispatch(loading(true));
  try {
    const request = await updateProfileApi(idPerfil, name, description, active);
    if (request.status === 200) {
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Perfil guardado con éxito",
          typeStyle: "success",
          displayTime: 5000
        })
      );
    } else {
      dispatch(getPerfiles());
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al guardar el perfil",
          typeStyle: "error",
          displayTime: 5000
        })
      );
    }
  } catch (e) {
    console.error(e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión al guardar el perfil",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};

export const doDeletePerfil = (idPerfil) => async (dispatch) => {
  dispatch(loading(true));
  try {
    const request = await deleteProfileApi(idPerfil);
    if (request.status === 200) {
      dispatch(getPerfiles());
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Perfil eliminado con éxito",
          typeStyle: "success",
          displayTime: 5000
        })
      );
    } else {
      dispatch(getPerfiles());
      dispatch(
        openCloseToast({
          isToastOpen: true,
          msgToast: "Error al eliminar el perfil",
          typeStyle: "error",
          displayTime: 5000
        })
      );
    }
  } catch (e) {
    console.error(e);
    dispatch(
      openCloseToast({
        isToastOpen: true,
        msgToast: "Error de conexión al eliminar el perfil",
        typeStyle: "error",
        displayTime: 5000
      })
    );
  }
  dispatch(loading(false));
};
